'use client'

import React from 'react'

type Props = {
    angleDegrees: number
}

const SIZE = 240
const CENTER = SIZE / 2
const RADIUS = 90

export default function UnitCircleChart({ angleDegrees }: Props) {
    const rad = (angleDegrees * Math.PI) / 180
    const cos = Math.cos(rad)
    const sin = Math.sin(rad)
    const px = CENTER + RADIUS * cos
    const py = CENTER - RADIUS * sin

    // Small arc showing the angle sweep from the positive x-axis to the terminal ray
    const arcRadius = 24
    const arcEndX = CENTER + arcRadius * cos
    const arcEndY = CENTER - arcRadius * sin
    const normalized = ((angleDegrees % 360) + 360) % 360
    const largeArc = normalized > 180 ? 1 : 0
    const sweep = 0

    return (
        <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`} style={{ maxWidth: '100%', height: 'auto' }}>
            {/* unit circle */}
            <circle cx={CENTER} cy={CENTER} r={RADIUS} fill="none" stroke="#d1d5db" strokeWidth={1.5} />
            {/* axes */}
            <line x1={CENTER - RADIUS - 15} y1={CENTER} x2={CENTER + RADIUS + 15} y2={CENTER} stroke="#9ca3af" strokeWidth={1} />
            <line x1={CENTER} y1={CENTER - RADIUS - 15} x2={CENTER} y2={CENTER + RADIUS + 15} stroke="#9ca3af" strokeWidth={1} />
            {/* angle sweep arc */}
            <path
                d={`M ${CENTER + arcRadius} ${CENTER} A ${arcRadius} ${arcRadius} 0 ${largeArc} ${sweep} ${arcEndX.toFixed(1)} ${arcEndY.toFixed(1)}`}
                fill="none"
                stroke="#a78bfa"
                strokeWidth={1.5}
            />
            {/* dashed reference legs (cos and sin) */}
            <line x1={px} y1={py} x2={px} y2={CENTER} stroke="#16a34a" strokeWidth={1.5} strokeDasharray="4,3" />
            <line x1={px} y1={CENTER} x2={CENTER} y2={CENTER} stroke="#2563eb" strokeWidth={1.5} strokeDasharray="4,3" />
            {/* terminal ray */}
            <line x1={CENTER} y1={CENTER} x2={px} y2={py} stroke="#dc2626" strokeWidth={2} />
            {/* point on circle */}
            <circle cx={px} cy={py} r={5} fill="#dc2626" stroke="#fff" strokeWidth={1.5} />
            {/* axis labels */}
            <text x={CENTER + RADIUS + 18} y={CENTER + 4} fontSize={11} fill="#6b7280">x</text>
            <text x={CENTER - 4} y={CENTER - RADIUS - 18} fontSize={11} fill="#6b7280">y</text>
            {/* coordinate label */}
            <text
                x={px + (cos >= 0 ? 8 : -8)}
                y={py + (sin >= 0 ? -8 : 16)}
                fontSize={11}
                textAnchor={cos >= 0 ? 'start' : 'end'}
                fill="#111827"
                fontWeight={600}
            >
                ({cos.toFixed(2)}, {sin.toFixed(2)})
            </text>
        </svg>
    )
}
